<template>
    <v-toolbar app color="primary">
        <v-layout row align-center>
            <v-flex shrink class="logo">
                <router-link :to="{ name: 'home' }">
                    <img :src="logo" />
                </router-link>
            </v-flex>
            <v-flex px-3>
                <v-select :items="demos"
                        :value="demo"
                        item-text="name"
                        item-value="component"
                        placeholder="Selecteer een demo"
                        class="w-100"
                        ref="select"
                        @change="goToDemo" />
            </v-flex>
            <v-flex shrink>
                <v-btn icon @click="showSettings = true">
                    <v-icon>settings</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showSettings">
            <settings-modal @close="showSettings = false" />
        </v-dialog>
    </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsModal from './SettingsModal'

export default {
    components: {
        SettingsModal,
    },
    data () {
        return {
            showSettings: false,
        }
    },
    computed: {
        ...mapGetters([
            'logo',
            'darkTheme',
            'lightTheme',
            'demos',
        ]),
        demo () {
            return this.$route.params.demo || null
        },
    },
    methods: {
        goToDemo (demo) {
            this.$router.push({ name: 'demos', params: { demo } })
            this.$refs.select.blur()
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .navbar-dark {
        .navbar-select {
            &:not(.multiselect--active) {
                .multiselect__placeholder {
                    color: #fff;
                }
            }
            .multiselect__select::before {
                border-color: #fff transparent transparent;
            }
        }
    }

    .navbar-light {
        .navbar-select {
            &:not(.multiselect--active) {
                .multiselect__placeholder {
                    color: #000;
                }
            }
            .multiselect__select::before {
                border-color: #000 transparent transparent;
            }
        }
    }

    .navbar-select {
        &:not(.multiselect--active) {
            .multiselect__tags {
                background: none;
                border: none;
            }
        }
    }

    .logo {
        min-width: 48px;
    }

    .logo img {
        max-width: 100%;
        max-height: 48px;
    }
</style>
